import { FormAction } from '@anytag/shared-types';
import { Form } from '@anytag/shared-atoms';
import { Template, TemplateProps } from './Template';
import { TikTokCampaignSchema } from './schema';
import { TikTokCampaignFormValues } from './types';
import { defaultTikTokCampaignFormValues } from './utils';

export type TikTokCampaignFormProps = FormAction<TikTokCampaignFormValues> & Omit<TemplateProps, 'onSubmit'>;

export const TikTokCampaignForm = ({ onSubmit, defaultValues, ...templateProps }: TikTokCampaignFormProps) => (
  <Form.Provider<TikTokCampaignFormValues>
    onSubmit={onSubmit}
    zodSchema={TikTokCampaignSchema}
    values={{ ...defaultTikTokCampaignFormValues, ...defaultValues }}
  >
    <Template {...templateProps} />
  </Form.Provider>
);

export * from './types';
export * from './utils';
